'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const IdTagIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="IdTagIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Tags-1--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Tags 1 Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M23.03 14.545a0.552 0.552 0 0 1 -0.249 1l-5.544 1.692 -1.693 5.543a0.551 0.551 0 0 1 -1 0.249L1.452 9.938a2.789 2.789 0 0 1 -0.708 -1.707L0.738 1.737a1 1 0 0 1 1 -1h6.491a2.782 2.782 0 0 1 1.707 0.707Z"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M3.737 5.737a2 2 0 1 0 4 0 2 2 0 1 0 -4 0Z"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

IdTagIcon.propTypes = {
  sx: PropTypes.object
}
